import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  credentialId: '',
  resource: 'actions',
  action: 'listActions',
  // Pagination
  page: 1,
  pageSize: 50,
  // Actions fields
  actionRef: '',
  subject: '',
  status: '',
  priority: '',
  category: '',
  actionOnUser: '',
  dueDate: '',
  notes: '',
  // Communications fields
  communicationId: '',
  contactRef: '',
  communicationType: '',
  communicationSubject: '',
  communicationBody: '',
  // Contact Addresses fields
  contactAddressId: '',
  addressContactRef: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  postcode: '',
  country: '',
  // Attachments fields
  attachmentRef: '',
  fileName: '',
  fileContent: '',
  relatedEntity: '',
  relatedEntityRef: '',
  // Advanced
  body: '',
};

export default defaults;
